import styled from 'styled-components';
import { COMMON, BORDER, LAYOUT, POSITION, FLEXBOX, GRID } from "../utils/system-props";
var Container = styled.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-zz2x1k-0"
})(["box-sizing:border-box;font-family:", ";", " ", " ", " ", " ", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
}, COMMON, BORDER, LAYOUT, POSITION, FLEXBOX, GRID);
export default Container;